<template>
<nav>
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{ name: 'providers' }">Providers</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'create_provider' }">New Provider</router-link></li>
    </li>
    <li
      v-if="providerId"
    >
      <router-link
        :to="{
          name: 'edit_provider',
          params: {
            providerId: providerId
          }
        }"
      >
        Edit Provider
      </router-link>
    </li>
    <li
      v-if="providerId"
    >
      <router-link
        :to="{
          name: 'provider_puzzles',
          params: {
            providerId: providerId
          }
        }"
      >
        Puzzles
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['providerId']
}
</script>



// WEBPACK FOOTER //
// src/components/ProviderNav.vue